import { action, observable } from 'mobx'
import { ANALYSIS_LIST, API_TYPE } from './constant'
import { message } from 'hljd'
import moment from 'moment'
import API from '@api/bi_nuo'

export default class Store {
  constructor(props = {}) {
    this.productType = props.productType
    this.onDataLoaded = props.onDataLoaded
  }
  // 数据分析-时间段
  @observable rangePickerValue
  @action
  changeRangePicker = () => (data, dateString) => {
    if (data && !data.length) {
      dateString = undefined
    }
    this.rangePickerValue = dateString
    this.dateRadioValue = ''
    this.getAnalysisData()
  }

  // 数据分析-时间单选按钮
  @observable dateRadioValue = '7'
  @action
  changeDateRadio = () => e => {
    this.dateRadioValue = e.target.value
    this.rangePickerValue = undefined
    this.getAnalysisData()
  }

  //婚纱摄影商家的夜间计划
  @observable typeValue = ''
  @action
  changeTypeRadio = e => {
    this.typeValue = e.target.value
    this.rangePickerValue = undefined
    this.getAnalysisData()
  }

  @action
  updateProps = (props = {}) => {
    this.productType = props.productType
    this.activeAnalysisTypeKey = this.productType + '@daily_display_count'
    this.getAnalysisData()
  }

  @observable dataSource = {}
  @action
  getAnalysisData = async () => {
    const { rangePickerValue, dateRadioValue, typeValue } = this
    let params = { type: typeValue }
    if (rangePickerValue) {
      params = Object.assign(params, {
        start_day: rangePickerValue[0],
        end_day: rangePickerValue[1]
      })
    } else if (dateRadioValue) {
      if (dateRadioValue == '1') {
        params = Object.assign(params, {
          start_day: moment()
            .subtract(Number(dateRadioValue), 'days')
            .format('YYYY-MM-DD'),
          end_day: moment()
            .subtract(Number(dateRadioValue), 'days')
            .format('YYYY-MM-DD')
        })
      } else {
        params = Object.assign(params, {
          start_day: moment()
            .subtract(Number(dateRadioValue), 'days')
            .format('YYYY-MM-DD'),
          end_day: moment().format('YYYY-MM-DD')
        })
      }
    } else {
      return message.error('时间不能为空！')
    }
    const { success, data } = await API[API_TYPE[this.productType]](params)
    if (success) {
      this.dataSource = data || {}
    }
    this.onDataLoaded && this.onDataLoaded(this.dataSource, params)
  }

  // 点击分析类型
  @observable activeAnalysisTypeKey = this.productType + '@daily_display_count'
  @observable labelTitle = '曝光展示(次)'
  @action
  handleClickAnalysisType = key => () => {
    this.activeAnalysisTypeKey = key
    setTimeout(() => {
      const labelTitleObj = (ANALYSIS_LIST[this.productType] || []).find(
        item => item.key === key
      )
      const unit = labelTitleObj.unit ? '(' + labelTitleObj.unit + ')' : ''
      this.labelTitle = labelTitleObj.label + unit
    }, 300)
  }
}
